var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#89959c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.597 7.67c0 3.453-6.093 12.917-6.093 12.917S1.41 11.123 1.41 7.67c0-3.452 2.728-6.25 6.094-6.25 3.365 0 6.093 2.798 6.093 6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.935 7.67c0 1.38-1.092 2.5-2.438 2.5S5.06 9.05 5.06 7.67s1.091-2.5 2.438-2.5c1.345 0 2.437 1.12 2.437 2.5z"
  }))));
}

export default SvgPoint;